export const EXCLUDED_COVERAGE_FILTER_PREFIX = 'excluded:' as const;

export const EXCLUDED_COVERAGE_FILTER_OPTIONS = [
  {
    id: 'excluded:duplicate-without-canonical',
    matchKey: 'duplicate without user-selected canonical',
    labelFa: 'Duplicate without user-selected canonical',
    description:
      'گوگل نسخه تکراری دیده و canonical انتخابی کاربر ندارد. در UI راهنمای جدا ندارد ولی در دیتابیس ذخیره می‌شود.',
    recommendWhen:
      'وقتی می‌خواهید فقط URLهای تکراری/کانونیکال مبهم را جدا بگیرید (مثلاً برای اصلاح canonical).',
  },
  {
    id: 'excluded:discovered-not-indexed',
    matchKey: 'discovered - currently not indexed',
    labelFa: 'Discovered — currently not indexed',
    description: 'گوگل URL را شناخته ولی هنوز کرول نکرده است.',
    recommendWhen:
      'وقتی می‌خواهید فقط صفحات تازه‌کشف‌شده‌ای که هنوز خزش نشده‌اند را پیگیری کنید.',
  },
  {
    id: 'excluded:crawled-not-indexed',
    matchKey: 'crawled - currently not indexed',
    labelFa: 'Crawled — currently not indexed',
    description: 'گوگل کرول کرده ولی عمداً ایندکس نکرده (معمولاً کیفیت محتوا).',
    recommendWhen:
      'وقتی می‌خواهید صفحاتی که خزش شده‌اند ولی ایندکس نشده‌اند را جدا ببینید.',
  },
  {
    id: 'excluded:noindex',
    matchKey: "excluded by 'noindex' tag",
    labelFa: "Excluded by 'noindex' tag",
    description: 'صفحه عمداً با تگ noindex از ایندکس خارج شده است.',
    recommendWhen:
      'وقتی فقط می‌خواهید اشتباهات noindex روی صفحات مهم را بگیرید (مثلاً مقاله یا محصول).',
  },
  {
    id: 'excluded:redirect',
    matchKey: 'page with redirect',
    labelFa: 'Page with redirect',
    description: 'این URL به آدرس دیگری ریدایرکت می‌شود و خودش ایندکس نمی‌شود.',
    recommendWhen:
      'وقتی می‌خواهید URLهای قدیمی که ریدایرکت دارند را جدا پیگیری کنید.',
  },
  {
    id: 'excluded:other',
    matchKey: '',
    labelFa: 'سایر حالت‌های ایندکس‌نشده',
    description:
      'هر coverageState دیگری که در موارد بالا نباشد (مثلاً URL is unknown to Google).',
    recommendWhen:
      'وقتی می‌خواهید همهٔ excludedها را بگیرید به‌جز چند حالت مشخص — آن حالت‌ها را خاموش کنید.',
  },
] as const;

export type ExcludedCoverageFilterId =
  (typeof EXCLUDED_COVERAGE_FILTER_OPTIONS)[number]['id'];

export const ALL_EXCLUDED_SUB_FILTER_IDS = EXCLUDED_COVERAGE_FILTER_OPTIONS.map(
  (item) => item.id,
);

export function getExcludedSubFilters(filters: string[]): string[] {
  return filters.filter((id) => id.startsWith(EXCLUDED_COVERAGE_FILTER_PREFIX));
}

export function isExcludedSubFilterExplicit(filters: string[]): boolean {
  return getExcludedSubFilters(filters).length > 0;
}

export function isExcludedSubFilterChecked(
  filters: string[],
  subId: string,
): boolean {
  const subs = getExcludedSubFilters(filters);
  if (subs.length === 0) return true;
  return subs.includes(subId);
}

export function toggleExcludedSubFilter(
  filters: string[],
  subId: string,
  checked: boolean,
): string[] {
  const withoutSubs = filters.filter(
    (id) => !id.startsWith(EXCLUDED_COVERAGE_FILTER_PREFIX),
  );
  const currentSubs = getExcludedSubFilters(filters);
  const allIds = ALL_EXCLUDED_SUB_FILTER_IDS;

  if (!checked) {
    if (!isExcludedSubFilterExplicit(filters)) {
      return [...withoutSubs, ...allIds.filter((id) => id !== subId)];
    }
    return [...withoutSubs, ...currentSubs.filter((id) => id !== subId)];
  }

  const nextSubs = [...new Set([...currentSubs, subId])];
  if (nextSubs.length === allIds.length) {
    return withoutSubs;
  }
  return [...withoutSubs, ...nextSubs];
}

export function toggleWebhookBucketFilter(
  filters: string[],
  bucketId: string,
  checked: boolean,
): string[] {
  if (checked) {
    return filters.includes(bucketId) ? filters : [...filters, bucketId];
  }
  if (bucketId === 'excluded') {
    return filters.filter(
      (id) => id !== bucketId && !id.startsWith(EXCLUDED_COVERAGE_FILTER_PREFIX),
    );
  }
  return filters.filter((id) => id !== bucketId);
}
